export default "__VITE_ASSET__CxOAp8Nm__"